import { useEffect, useState } from "react";
import { Typography, Divider } from "@mui/material";
import { t } from "i18next";
import { RedWarningIcon } from "../assets/images";
import { MuiPopup, MuiStack, MuiButton } from "../components";
import { MuiLoaderButton } from "../components/atoms/loaderButton";
export var TimeZoneDialog = function (_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, handleDiscardClick = _ref.handleDiscardClick, handleConfirmClick = _ref.handleConfirmClick, detectedOffset = _ref.detectedOffset, detectedZone = _ref.detectedZone, expectedOffset = _ref.expectedOffset, expectedLabel = _ref.expectedLabel;
    var _a = useState(null), platformInstruction = _a[0], setPlatformInstruction = _a[1];
    var _b = useState(false), isWindows = _b[0], setIsWindows = _b[1];
    useEffect(function () {
        var ua = navigator.userAgent;
        setIsWindows(/Windows/i.test(ua));
        if (!/Windows/i.test(ua))
            setPlatformInstruction(getPlatformInstruction(ua));
    }, []);
    var getPlatformInstruction = function (ua) {
        if (/Macintosh/i.test(ua)) {
            return t("On macOS: Apple Menu -> System Settings -> General -> Date & Time");
        }
        else if (/Android/i.test(ua)) {
            return t("On Android: Settings -> System -> Date & Time");
        }
        else if (/iPhone|iPad/i.test(ua)) {
            return t("On iOS: Settings -> General -> Date & Time");
        }
        else {
            return t("Please update your system time zone from your device settings.");
        }
    };
    var handleUpdateClick = function () {
        if (isWindows) {
            window.open("ms-settings:dateandtime", "_blank");
            handleConfirmClick === null || handleConfirmClick === void 0 || handleConfirmClick();
        }
    };
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: isOpen,
        closeIcon: true,
        backdropEnable: true,
        onClose: onClose || handleDiscardClick,
        padding: "25px 0px 0px 25px",
        headerIcon: RedWarningIcon
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        padding: 0,
        margin: 0
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: '18px',
        fontWeight: '600'
    }, t("Time Zone Mismatch Detected")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: '14px',
        fontWeight: '400',
        color: "secondary.600",
        marginTop: 2
    }, t("Your current system time zone does not match your actual location.")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: '14px',
        fontWeight: '500',
        marginTop: 1
    }, t("Detected"), ": UTC", detectedOffset, " (", detectedZone, ") ", /*#__PURE__*/ React.createElement("br", null), t("Expected"), ": ", expectedOffset, " (", expectedLabel, ")"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: '14px',
        fontWeight: '400',
        color: "secondary.600",
        marginTop: 2
    }, t("Please update your time zone settings to ensure accurate data and proper functioning.")), platformInstruction && /*#__PURE__*/ React.createElement(Typography, {
        fontSize: '13px',
        fontWeight: '500',
        color: "error.main",
        marginTop: 2,
        sx: {
            whiteSpace: 'pre-line'
        }
    }, platformInstruction), /*#__PURE__*/ React.createElement(Divider, {
        flexItem: true,
        sx: {
            py: 1,
            my: 2
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: {
            xs: "column",
            sm: "row-reverse"
        },
        spacing: 2,
        justifyContent: "end",
        alignItems: "center",
        width: "100%"
    }, isWindows && /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "update-btn",
        size: "medium",
        fullWidth: true,
        sx: {
            width: {
                xs: "100%",
                sm: "auto"
            }
        },
        name: t("Update Time Zone Now"),
        variant: "contained",
        onClick: handleUpdateClick
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        id: "remind-btn",
        size: "medium",
        fullWidth: true,
        sx: {
            width: {
                xs: "100%",
                sm: "auto"
            },
            border: "1px solid",
            borderColor: "secondary.600",
            color: "".concat(isWindows ? "secondary.600" : "#fff")
        },
        name: t("Discard"),
        variant: "".concat(isWindows ? "outlined" : "contained"),
        onClick: handleDiscardClick
    }))));
};
